<script>
import { SiteSettings } from '@/api/'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { Logotypes } from '@/api'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.ColorSelect({
              label: 'Kolor (domyślnie Podstawowy)',
              modelPath: [this, 'form', 'color']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.ForeignKey({
              label: 'Logotypy',
              modelPath: [this, 'form', 'logotypes'],
              labelField: 'name',
              required: true,
              service: Logotypes
            })
          ]
        }
      ]
    }
  }
}
</script>
